import React from 'react';
import { useSelector } from 'react-redux';

import { Popup } from '@travel/ui';

import { getItem } from 'store/providerInformation/selectors';

import { Translate } from 'core/translate';

import styles from './noAccountNeededPopup.module.scss';

type Props = {
  isOpen: boolean;
};

function NoAccountNeededPopup(props: Props) {
  const { isOpen } = props;
  const { name: providerName } = useSelector(getItem);
  return (
    <Popup isOpen={isOpen} onClose={() => {}} className={styles.messageWrapper}>
      <h2 className={styles.title}>{providerName}</h2>
      <div className={styles.descriptionHolder}>
        <div className={styles.description}>
          <Translate id="Provider_Info.Reserve.Pop_up_Message" />
        </div>
      </div>
    </Popup>
  );
}

export default NoAccountNeededPopup;
